// src/modules/app-views/_apps/appmulti/coupons/pages/Init/components/tableColumns/remainingColumn.js
import translateX from 'utils/translateX';

function remainingColumn(buildColumnProps, options = {}) {
  const {
    key = 'remaining',
    title = 'quantity',
    dataIndex = 'qty',
    width = 130,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'center',
    render: (_, r) => {
      const qty = Number(r?.qty) || 0;
      const used = Number(r?.usedCount) || 0;
      const remaining = r?.__remaining != null ? r.__remaining : Math.max(0, qty - used);
      return (
        <span>
          {remaining} / {qty}
        </span>
      );
    },
  };
}

export default remainingColumn;
